/**
 * Local saved-trips store. Works for guests (no auth required).
 * Authenticated users save to server too (see api.saveItinerary) and we cache here as well.
 */
const KEY = "vybe_saved_v1";

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function write(items) {
  try {
    localStorage.setItem(KEY, JSON.stringify(items.slice(0, 50)));
  } catch {
    // quota exceeded — drop oldest
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, 20)));
    } catch {}
  }
}

export const localSavedStore = {
  list() {
    return read().sort((a, b) => (b.saved_at || 0) - (a.saved_at || 0));
  },
  has(id) {
    return read().some((t) => t.id === id);
  },
  upsert(itin) {
    const items = read();
    const idx = items.findIndex((t) => t.id === itin.id);
    const slim = {
      id: itin.id,
      title: itin.title,
      subtitle: itin.subtitle,
      destination: itin.destination,
      destination_recommendation: itin.destination_recommendation,
      cover_image: itin.cover_image,
      viral_score: itin.viral_score,
      duration_days: itin.duration_days,
      vibe_tags: itin.vibe_tags || [],
      saved_at: Date.now(),
    };
    if (idx >= 0) items[idx] = slim; else items.unshift(slim);
    write(items);
    return slim;
  },
  remove(id) {
    write(read().filter((t) => t.id !== id));
  },
  clear() { write([]); },
};
